export default "__VITE_ASSET__D8WsLC2h__"